import './form-field.scss';

import { components } from 'gridstrap/lib/gs-components';
import { GSFormFieldInput } from './form-field-input';
import { GSFormFieldSelect } from './form-field-select';
import { GSFormFieldTextarea } from './form-field-textarea';

components.register({
	selector: '.gs-FormField--input',
	controller: GSFormFieldInput
});

components.register({
	selector: '.gs-FormField--select',
	controller: GSFormFieldSelect
});

components.register({
	selector: '.gs-FormField--textarea',
	controller: GSFormFieldTextarea
});
